module.exports = __webpack_public_path__ + "static/media/robosgdemo.738bf27d.jpeg";